var map = [
  ['Battlefield of Eternity', 1, {bg_class: 'map-battlefield-of-eternity'}],
  ['Blackheart\'s Bay', 1, {bg_class: 'map-blackheart-bay'}],
  ['Cursed Hollow', 1, {bg_class: 'map-cursed-hollow'}],
  ['Dragon Shire', 1, {bg_class: 'map-dragon-shire'}],
  ['Garden of Terror', 1, {bg_class: 'map-garden-of-terror'}],
  ['Haunted Mines', 1, {bg_class: 'map-haunted-mine'}],
  ['Infernal Shrines', 1, {bg_class: 'map-infernal-shrines'}],
  ['Sky Temple', 1, {bg_class: 'map-sky-temple'}],
  ['Tomb of the Spider Queen', 1, {bg_class: 'map-tomb-of-the-spider-queen'}],
  ['Towers of Doom', 1, {bg_class: 'map-tower-of-doom'}]
]

export default map



// WEBPACK FOOTER //
// ./src/data/map.js